export const ConfidentialityLevel = {
  public: "Public",
  public_display: "Public",
  internal: "Internal",
  internal_display: "Internal",
  confidential: "Confidential",
  confidential_display: "Confidential",
  strictlyConfidential: "StrictlyConfidential",
  strictlyConfidential_display: "Strictly confidential",
};
export const LocationType = {
  online: "Online",
  online_display: "Online",
  onPremise: "OnPremise",
  onPremise_display: "OnPremise",
};
export const PermissionRole = {
  none: "None",
  none_display: "None",
  reader: "Reader",
  reader_display: "Reader",
  contributor: "Contributor",
  contributor_display: "Contributor",
  administrator: "Administrator",
  approver: "Approver",
  approver_display: "Approver",
  administrator_display: "Administrator",
  pGEmployee: "PGEmployee",
  pGEmployee_display: "PGEmployee",
  owner: "Owner",
  owner_display: "Owner",
};
export const SiteType = {
  teamSite: "TeamSite",
  teamSite_display: "Team site",
  communicationSite: "CommunicationSite",
  communicationSite_display: "Communication site",
  classicSite: "ClassicSite",
  classicSite_display: "Classic Site",
  team: "Team",
  team_display: "Team",
  group: "Group",
  group_display: "Group",
  rdarchive: "R&D Project",
  rdarchive_display: "R&D Project",
};
export const SiteStatus = {
  creating: "Creating",
  creating_display: "Creating",
  active: "Active",
  active_display: "Active",
  canceled: "Canceled",
  canceled_display: "Canceled",
  deleted: "Deleted",
  deleted_display: "Deleted",
  pendingApproval: "PendingApproval",
  pendingApproval_display: "Pending Approval",
  rejected: "Rejected",
  rejected_display: "Rejected",
  expired: "Expired",
  expired_display: "Expired",
  disabled: "Disabled",
  disabled_display: "Disabled",
  archived: "Archived",
  archived_display: "Archived",
  pernamently_deleted: "Pernamently Deleted",
  pernamently_deleted_display: "Pernamently Deleted",
};
export const AttentionType = {
  quotaHigh: "QuotaHigh",
  quotaHigh_display: "High quota",
  quotaExceeded: "QuotaExceeded",
  quotaExceeded_display: "Quota exceeded",
  emptyOwner: "EmptyOwner",
  emptyOwner_display: "Empty owner",
  expirationSoon: "ExpirationSoon",
  expirationSoon_display: "Expiration soon",
  expired: "Expired",
  expired_display: "Expired",
};
export const ProvisioningStatus = {
  ready: "Ready",
  ready_display: "Ready",
  enqueued: "Enqueued",
  enqueued_display: "Enqueued",
  creating: "Creating",
  creating_display: "Creating",
  created: "Created",
  created_display: "Created",
  updating: "Updating",
  updating_display: "Updating",
  failed: "Failed",
  failed_display: "Failed",
  permanentFailed: "PermanentFailed",
  permanentFailed_display: "Permanent failed",
  readOnly: "ReadOnly",
  readOnly_display: "Read only",
  noAccess: "NoAccess",
  noAccess_display: "No access",
};

export const QARTaskType = {
  quarterlyCustomApps: 0,
  quarterlyCustomApps_display: "Quarterly access review - Custom Apps",

  quarterlyOnline: 1,
  quarterlyOnline_display: "Quarterly access review - Sharepoint Online",

  quarterlyOneDrive: 2,
  quarterlyOneDrive_display: "Quarterly access review - OneDrive",

  securityAwareness: "Security awareness",
  securityAwareness_display: 3,

  confidentialityCheck: 4,
  confidentialityCheck_display: "Confidentiality check",
};
export const QarTaskStatus = {
  Pending: 0,
  Completed: 1,
  Expired: 2,
  Canceled: 3,
};
export const ChangeTaskType = {
  status: "Status",
  status_display: "Status",
  owner: "Owner",
  owner_display: "Owner",
  quota: "Quota",
  quota_display: "Quota",
  expiration: "Expiration",
  expiration_display: "Expiration",
  gdpr: "Gdpr",
  gdpr_display: "Gdpr",
  sensitiveGdpr: "SensitiveGdpr",
  sensitiveGdpr_display: "SensitiveGdpr",
  confidentiality: "Confidentiality",
  confidentiality_display: "Confidentiality",
  externalCollaboration: "ExternalCollaboration",
  externalCollaboration_display: "ExternalCollaboration",
  teamsOwnerAdd: "TeamsOwnerAdd",
  teamsOwnerAdd_display: "Add Team owners",
  teamsOwnerRemove: "TeamsOwnerRemove",
  teamsOwnerRemove_display: "Remove Team owners",
  siteAudience: "SiteAudience",
  siteAudience_display: "SiteAudience",
  management: "Management",
  management_display: "Management",
  projectManager: "ProjectManager",
  projectManager_display: "Project Manager",
  sponsor: "Sponsor",
  sponsor_display: "Sponsor",
  steeringCommitteeAdd: "SteeringCommitteeAdd",
  steeringCommitteeAdd_display: "Add Steering Committee",
  steeringCommitteeRemove: "SteeringCommitteeRemove",
  steeringCommitteeRemove_display: "Remove Steering Committee",
  sponsorAdd: "SponsorAdd",
  sponsorAdd_display: "Add Sponsor",
  sponsorRemove: "SponsorRemove",
  sponsorRemove_display: "Remove Sponsor",
  emptyOwner: "Empty Owner",
  emptyOwner_display: "Empty Owner",
  delete: "Delete",
  delete_display: "Delete",
};

export const PrefixOptions = [
  { key: "CPI", text: "CPI - Continuous Product Improvement" },
  { key: "TS", text: "TS - Technology Scouting" },
  { key: "MP", text: "MP - Manufacturing Development" },
  { key: "NP", text: "NP - New Product" },
  { key: "PD", text: "PD - Next Generation Product" },
  { key: "PE", text: "PE - Product Enhancement" },
  { key: "TP", text: "TP - Product Scouting" },
  { key: "PM", text: "PM - Product Maintenance" },
  { key: "TI", text: "TI - Method and Tool Development" },
  { key: "TD", text: "TD - Technology Development" },
];



// WEBPACK FOOTER //
// ./src/GlobalConst/globalEnums.js